import axiosClient from "@/core/axios";
import { CompanyProfile, CompanyProfileRequest, IResponse } from "@/shared/interfaces";

const companyProfileApi = {
  getCompanyProfiles: (): Promise<IResponse<CompanyProfile[]>> => axiosClient.get("/company-profiles"),
  getCompanyProfile: (id: number): Promise<IResponse<CompanyProfile>> => axiosClient.get(`/company-profiles/${id}`),
  createCompanyProfile: (data: CompanyProfileRequest): Promise<IResponse<CompanyProfile>> => axiosClient.post("/company-profiles", data),
  updateCompanyProfile: (id: number, data: CompanyProfileRequest): Promise<IResponse<CompanyProfile>> =>
    axiosClient.patch(`/company-profiles/${id}`, data),
};

export default companyProfileApi;
